export default __webpack_public_path__ + "static/media/11.a5cc87e3.jpeg";